/**
 * Update field objects if they need to have errors added
 *
 * Used in Svelte forms, called when form is submitted
 *
 * @param {Object[]} fields - fields to add errors to if needed
 */
function addErrorsToFields(fields) {
  fields.forEach(field => {
    // is field blank, or has it not been touched?
    if (field.value.length === 0 || !field.touched) {
      // Svelte's reactive assignment does stuff when the field's properties are updated, look at the form $: if (isSending && fieldsHaveErrors) {} to see how this works
      field.error = true;
      field.touched = true;
    }
  });
}

export default addErrorsToFields;



// WEBPACK FOOTER //
// ./scripts/util/validation/addErrorsToFields.js